import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import {
  Divider,
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableBody,
  Grid,
  Paper,
  ListItem,
} from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import SnackBar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";

import CancelIcon from "@material-ui/icons/Cancel";
import InfoIcon from "@material-ui/icons/Info";
import DeleteIcon from "@material-ui/icons/Delete";

import { url } from "../../../../config/config";
import NavBar from "../../../../Component/NavBar/AdminHeader/AdminHeader";
import Axios from "axios";
import CustomDialog from "../../../../Component/DialogBox/CustomDialog";
import CustomTableHead from "../../../../Component/Table/CustomTableHead/CustomTableHead";
import CustomTableFooter from "../../../../Component/Table/CutomTableFooter/CustomTableFooter";
import { adminLogout } from "../../../../redux/action/action";
import CustomLoader from "../../../../Component/CustomLoader/CustomLoader";
import CustomEmptyMessage from "../../../../Component/CustomEmptyMessage/CustomEmptyMessage";
import SessionExpiredDialog from "../../../../Component/SessionExpiredDialog/SessionExpiredDialog";
import { useStyles } from "./ViewMessages.css";
import AdminPageTitle from "../../../../Component/AdminPageTitle/AdminPageTitle";
import MessageFilter from "../MessageFilter/MessageFilter";

class ViewMessages extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 0,
      rowsPerPage: 5,
      column: [
        {
          name: "S.N.",
        },
        {
          name: "For Book",
        },
        {
          name: "Author",
        },
        {
          name: "Author's Email",
        },
        {
          name: "Messaged Date",
        },
        {
          name: "Actions",
        },
      ],
      search: {
        date: "",
      },
      messages: [],
      dialogOpen: false,
      isEmpty: false,
      messageToDelete: "",
      notificationOpen: false,
      sessionExpired: false,
      detailStatus: false,
      detailData: {},
    };
  }

  componentDidMount() {
    this.getData();
  }

  getData = async () => {
    try {
      const response = await Axios.get(`${url}/api/messages`, {
        headers: {
          "x-auth-token": this.props.adminToken,
        },
      });
      if (response.data.messages.length !== 0) {
        this.setState({
          messages: response.data.messages,
          isEmpty: false,
        });
      } else {
        this.setState({
          messages: [],
          isEmpty: true,
        });
      }
    } catch (error) {
      if (error.response.data === "Invalid token.") {
        this.setState({ sessionExpired: true });
      }
    }
  };

  handleSearch = (e) => {
    this.setState({ search: { date: e.target.value } });
  };

  handlePage = (e, newPage) => {
    this.setState({
      page: newPage,
    });
  };

  handleRowsPerPage = (e) => {
    this.setState({
      rowsPerPage: +e.target.value,
      page: 0,
    });
  };

  handleNotificationOpen = () => {
    this.setState({
      notificationOpen: true,
    });
  };

  handleNotificationClose = () => {
    this.setState({
      notificationOpen: false,
    });
  };

  showNotification = (notificationStyle) => {
    return (
      <SnackBar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={this.state.notificationOpen}
        onClose={this.handleNotificationClose}
        className={notificationStyle}
        autoHideDuration={1600}
      >
        <MuiAlert
          onClose={this.handleNotificationClose}
          severity="error"
          elevation={6}
          variant="filled"
        >
          Deleted Successfully
        </MuiAlert>
      </SnackBar>
    );
  };

  handleDeleteMessage = async () => {
    let response = await Axios.delete(
      `${url}/api/messages/${this.state.messageToDelete}`,
      {
        headers: {
          "x-auth-token": this.props.adminToken,
        },
      }
    );
    if (response.data.success) {
      this.handleDialogClose();
      this.handleNotificationOpen();
      this.getData();
    }
  };

  handleEditMessage = (messageId) => {
    this.props.history.push(`/_administration_/messages/edit/${messageId}`);
  };

  handleCancelDetailMessage = () => {
    this.setState({ detailStatus: false });
  };
  handleDetailMessage = (message) => {
    this.setState({ detailStatus: true, detailData: message });
  };

  handleDialogOpen = (messageId) => {
    this.setState({
      dialogOpen: true,
      messageToDelete: messageId,
    });
  };

  handleDialogClose = () => {
    this.setState({
      dialogOpen: false,
    });
  };

  render() {
    const { rowsPerPage, page } = this.state;
    const { classes } = this.props;
    let filtered = this.state.messages.filter((data) => {
      return data.createdAt.indexOf(this.state.search.date) !== -1;
    });
    return (
      <div>
        <NavBar />
        <div className={classes.root}>
          {this.state.sessionExpired === true && (
            <SessionExpiredDialog logout={() => this.props.adminLogout()} />
          )}

          <AdminPageTitle title="Messages" refreshUrl={this.props.match.url} />
          <Divider />
          <br />

          <MessageFilter
            data={this.state.search}
            handleChange={this.handleSearch}
          />

          <div>
            {this.state.messages.length !== 0 ? (
              <Grid container spacing={3}>
                <Grid
                  item
                  sx={12}
                  sm={12}
                  md={this.state.detailStatus ? 8 : 12}
                  xl={this.state.detailStatus ? 8 : 12}
                  lg={this.state.detailStatus ? 8 : 12}
                >
                  <TableContainer>
                    <Table>
                      <CustomTableHead column={this.state.column} />
                      <TableBody>
                        {(rowsPerPage > 0
                          ? filtered.slice(
                              page * rowsPerPage,
                              page * rowsPerPage + rowsPerPage
                            )
                          : filtered
                        ).map((message, index) => (
                          <TableRow
                            key={index}
                            style={{
                              backgroundColor: `${
                                index % 2 ? "#eee" : "white"
                              }`,
                            }}
                          >
                            <TableCell align="center">{index + 1}</TableCell>
                            <TableCell align="center">
                              {message.bookId.title}
                            </TableCell>
                            <TableCell align="center">
                              {message.authorId.firstName}{" "}
                              {message.authorId.middleName}{" "}
                              {message.authorId.lastName}
                            </TableCell>
                            <TableCell align="center">
                              {message.authorId.email}
                            </TableCell>
                            <TableCell align="center">
                              {message.createdAt}
                            </TableCell>
                            <TableCell
                              align="center"
                              style={{ alignContent: "center" }}
                            >
                              <Tooltip
                                arrow
                                title="View details"
                                className={classes.tooltip}
                                onClick={() =>
                                  this.handleDetailMessage(message)
                                }
                              >
                                <InfoIcon />
                              </Tooltip>
                              <Tooltip
                                arrow
                                title="Delete"
                                className={classes.tooltip}
                                onClick={() =>
                                  this.handleDialogOpen(message._id)
                                }
                              >
                                <DeleteIcon />
                              </Tooltip>
                            </TableCell>
                            <CustomDialog
                              open={this.state.dialogOpen}
                              handleClose={this.handleDialogClose}
                              handleDelete={this.handleDeleteMessage}
                            />
                          </TableRow>
                        ))}
                      </TableBody>
                      <CustomTableFooter
                        count={this.state.messages.length}
                        rowsPerPage={this.state.rowsPerPage}
                        page={this.state.page}
                        onChangePage={this.handlePage}
                        onChangeRowsPerPage={this.handleRowsPerPage}
                      />
                    </Table>
                    {this.showNotification(classes.notificationStyle)}
                  </TableContainer>
                </Grid>
                {this.state.detailStatus && (
                  <Grid item sx={12} sm={12} md={4} xl={4} lg={4}>
                    <Paper style={{ padding: 10 }}>
                      <div style={{ display: "flex" }}>
                        <b style={{ flexGrow: 1 }}>Message Details</b>
                        <Tooltip
                          arrow
                          title="Close"
                          className={classes.tooltip}
                          onClick={() => this.handleCancelDetailMessage()}
                        >
                          <CancelIcon />
                        </Tooltip>
                      </div>
                      <div>
                        <ListItem divider>
                          <b style={{ flexGrow: 1 }}>Email</b>
                          {this.state.detailData.authorId.email}
                        </ListItem>
                        <ListItem divider>
                          <b style={{ flexGrow: 1 }}>For Book</b>
                          {this.state.detailData.bookId.title}
                        </ListItem>
                        <div style={{ textAlign: "center", padding: 5 }}>
                          {this.state.detailData.message}
                        </div>
                      </div>
                    </Paper>
                  </Grid>
                )}
              </Grid>
            ) : this.state.isEmpty === true ? (
              <CustomEmptyMessage message="No data present in the database" />
            ) : (
              <CustomLoader />
            )}
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    adminLogout: () => {
      dispatch(adminLogout());
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(ViewMessages)));
